import { useFormikContext, FormikContextType } from 'formik'

import { Note } from 'src/components/atoms/Note'
import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { CalculatorTab, CarbonCalculatorValues } from '../types'

export const StemsEmissionsFormFields = () => {
  const { values }: FormikContextType<CarbonCalculatorValues> =
    useFormikContext()

  return (
    <>
      {values.formTab === CalculatorTab.Carbon ? (
        <FormField
          id='emissions'
          formFieldClassName='bg-white'
          type={FormFieldTypes.number}
          label='Emissions (tCO₂ equivalent)'
        />
      ) : (
        <FormField
          id='stems'
          formFieldClassName='bg-white'
          type={FormFieldTypes.text}
          label='No. of stems planted'
          placeholder='0'
        />
      )}
      <FormField
        id='age'
        formFieldClassName='bg-white'
        type={FormFieldTypes.number}
        label='Age of stand (years)'
      />
      {values.age && values.age < 20 ? (
        <Note type='warning'>
          Warning, your stand age is very young. Trees do not sequester much
          carbon in the first few years after planting. We suggest you increase
          age to at least 20 years.
        </Note>
      ) : null}
    </>
  )
}
